<template>
  <!--  技术支持 -->
  <div class="">
    <HeaderTop />
    <MenuPage />

    <BannerDetail
      :backgroundImage="require('../assets/img/banner10.jpg')"
      :title="$t('bannertitle')"
      :description="$t('bannerdescription')"
    />

     <!-- <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Technical") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div> -->

     


    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("ServiceProcess1") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

    <div class="ServiceProcess-mian">
      <div class="one-main">
        <div class="ServiceProcess-box">
          <div>
            <img src="../assets/img/shi1.png" class="ServiceProcess-img" />
          </div>
          <div class="ServiceProcess-title">{{ $t("ServiceProcess2") }}</div>
          <div class="ServiceProcess-bottom">
            <div>
              <span class="title-one">1、{{ $t("ServiceProcess5") }}：</span>
              <span class="title-two">{{ $t("ServiceProcess8") }}</span>
            </div>
            <div>
              <span class="title-one">2、{{ $t("ServiceProcess6") }}：</span>
              <span class="title-two">{{ $t("ServiceProcess9") }}</span>
            </div>
            <div>
              <span class="title-one">3、{{ $t("ServiceProcess7") }}：</span>
              <span class="title-two">{{ $t("ServiceProcess10") }}</span>
            </div>
          </div>
        </div>
        <div class="ServiceProcess-box">
          <div>
            <img src="../assets/img/shi2.png" class="ServiceProcess-img" />
          </div>
          <div class="ServiceProcess-title">{{ $t("ServiceProcess3") }}</div>
          <div class="ServiceProcess-bottom">
            <div>
              <span class="title-one">1、{{ $t("ServiceProcess11") }}：</span>
              <span class="title-two">{{ $t("ServiceProcess14") }}</span>
            </div>
            <div>
              <span class="title-one">2、{{ $t("ServiceProcess12") }}：</span>
              <span class="title-two">{{ $t("ServiceProcess15") }}</span>
            </div>
            <div>
              <span class="title-one">3、{{ $t("ServiceProcess13") }}：</span>
              <span class="title-two">{{ $t("ServiceProcess16") }}</span>
            </div>
          </div>
        </div>
        <div class="ServiceProcess-box">
          <div>
            <img src="../assets/img/shi3.png" class="ServiceProcess-img" />
          </div>
          <div class="ServiceProcess-title">{{ $t("ServiceProcess4") }}</div>
          <div class="ServiceProcess-bottom">
            <div>
              <span class="title-one">1、{{ $t("ServiceProcess17") }}：</span>
              <span class="title-two">{{ $t("ServiceProcess19") }}</span>
            </div>
            <div>
              <span class="title-one">2、{{ $t("ServiceProcess18") }}：</span>
              <span class="title-two">{{ $t("ServiceProcess20") }}</span>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("contactUs") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

    <div class="ServiceProcess-contact">
      <div class="contact-box">
        <div class="mg20">
          <span class="title-two">{{ $t("ServiceProcess21") }}</span>
        </div>
        <div>
          <form @submit.prevent="handleSubmit">
            <div>
              <label for="companyName">{{ $t("ServiceProcess22") }}:</label>
              <input
                type="text"
                id="companyName"
                v-model="companyName"
                
              />
            </div>
            <div>
              <label for="contactPerson">{{ $t("ServiceProcess23") }}:</label>
              <input
                type="text"
                id="contactPerson"
                v-model="contactPerson"
                
              />
            </div>
            <div>
              <label for="contactInfo">{{ $t("ServiceProcess24") }}:</label>
              <input
                type="text"
                id="contactInfo"
                v-model="contactInfo"
                
              />
            </div>
            <div>
              <label for="requirements">{{ $t("ServiceProcess25") }}:</label>
              <textarea
                id="requirements"
                v-model="requirements"
                rows="4"
                
              ></textarea>
            </div>
            <div class="text-main">
              <button type="submit">{{ $t("ServiceProcess26") }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="footer-main">
      {{ $t("footertitile") }}
    </div>
  </div>
</template>

<script>
import MenuPage from "../components/MenuPage.vue";
import HeaderTop from "../components/HeaderTop.vue";
import BannerDetail from "@/components/BannerDetail.vue";
import request from '@/utils/request'

export default {
  components: { HeaderTop, MenuPage, BannerDetail },
  name: "NewsPage",
  data() {
    return {
      companyName: "",
      contactPerson: "",
      contactInfo: "",
      requirements: "",
    };
  },
  methods: {
    handleSubmit() {
      // 阻止表单的默认提交行为
      // 这里可以添加进一步的逻辑，比如将表单数据发送到服务器
      console.log({
        companyName: this.companyName,
        contactPerson: this.contactPerson,
        contactInfo: this.contactInfo,
        requirements: this.requirements,
      });
      request.post('/hkbr/customer/webAdd', {
        corporateName: this.companyName,
        contacts: this.contactPerson,
        phone: this.contactInfo,
        content: this.requirements,
        source:"support"
      }).then(data=>{
        console.log(data);
        this.companyName="";
        this.contactPerson="";
        this.contactInfo="";
        this.requirements="";
        alert("提交成功"); // 提示提交成功
      })
    },
  },
};
</script>
<style scoped>
.ServiceProcess-mian {
  float: left;
  width: 100%;
  background: #f6f6f6;
  padding: 0 50px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.one-main {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
}

.ServiceProcess-box {
  float: left;
  width: 33.33%;
  background: #fff;
  border-right: 1px solid #eee;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
}
.ServiceProcess-title {
  font-size: 24px;
  color: #4a4a4a;
  margin: 20px 0;
}
.ServiceProcess-img {
  width: 170px;
  height: 150px;
}
.ServiceProcess-bottom {
  padding: 20px;
  box-sizing: border-box;
  text-align: left;
}
.ServiceProcess-bottom div {
  margin-bottom: 20px;
}
.title-one {
  color: #4a4a4a;
  font-weight: 800;
}
.title-two {
  color: #666;
}
.ServiceProcess-contact {
  float: left;
  width: 100%;
  background: #f6f6f6;
  padding: 0 50px 50px 50px;
  box-sizing: border-box;
}
.contact-box {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
input[type="text"],
textarea {
  width: 100%;
  padding: 8px;
    box-sizing: border-box;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.text-main {
  width: 100%;
  text-align: center;
}
button {
  padding: 10px 15px;
  background-color: #ca391b;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background-color: #ca391b;
}
.mg20 {
  margin-bottom: 20px;
}
@media (max-width: 1200px) {
  .ServiceProcess-mian {
    flex-direction: column;
    padding: 0 10px;
  }
  .ServiceProcess-box {
    width: 100%;
    margin-bottom: 20px;
  }
  .ServiceProcess-title {
    font-size: 18px;
    color: #4a4a4a;
  }
  .ServiceProcess-contact {
    padding: 0 10px;
  }
  .contact-box {
    width: 100%;
  }
  .one-main {
    float: left;
    width: 100%;
  }
}
</style>
